export default () => {
  const elms = document.querySelectorAll( '.immocard__wrapper.modal' );

  if ( !elms ) {
    return;
  }

  elms.forEach( ( elm ) => {
    elm.addEventListener( 'click', function(e) {
      e.preventDefault();
      const shadow = elm.parentNode.querySelector( 'swt-plugin' ).shadowRoot;

      if (shadow) {
        const modal_button = shadow.querySelector( 'swt-modal button' );
        modal_button.click();
      }
    } )
  } );
}
